import { Button } from '@amzn/stencil-react-components/button';
import { Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { PopoverController, PopoverPosition } from '@amzn/stencil-react-components/popover';
import { Label, Text } from '@amzn/stencil-react-components/text';
import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { displayNotification } from '../../actions/notificationActions';
import {
  ADDRESS_COLUMN_INFO,
  CHANNEL_TYPE_INFO,
  CSV_TEMPLATE_HEADERS,
} from '../../constants/messages';

import { IconDownload } from '@amzn/stencil-react-icons';

const DownloadTemplate = () => {
  const templateIcon = useRef();
  const dispatch = useDispatch();

  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const toggle = () => setIsInfoOpen(!isInfoOpen);
  const close = () => setIsInfoOpen(false);

  const downloadTemplate = () => {
    const blob = new Blob([CSV_TEMPLATE_HEADERS], { type: 'data:text/csv;charset=utf-8,' });
    const blobURL = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = 'Nudge_segment_template.csv';
    anchor.href = blobURL;
    anchor.dataset.downloadurl = ['text/csv', anchor.download, anchor.href].join(':');
    anchor.click();
    dispatch(
      displayNotification({
        message: 'Template downloaded successfully',
        type: 'success',
        timeout: 1000,
      }),
    );
  };

  return (
    <View onMouseEnter={toggle} onMouseLeave={close}>
      <Button ref={templateIcon} hasIcon tertiary>
        <Row gridGap="S200" alignItems="center">
          <IconDownload aria-hidden={true} />
          <FormattedMessage
            id="app.createSegment.downloadCsvLabel"
            defaultMessage="Download Template.csv"
          />
        </Row>
      </Button>
      <PopoverController
        target={templateIcon}
        position={PopoverPosition.TopCenter}
        close={close}
        isOpen={isInfoOpen}
      >
        <View padding={15} display="flex" width={400} flexDirection="column" gridGap={10}>
          <Text fontWeight={'bold'}>
            <FormattedMessage
              id="app.templateCSV.message.mandatoryColumns"
              defaultMessage="Mandatory Colums"
            />
          </Text>
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage
                id="app.templateCSV.message.channelType"
                defaultMessage="ChannelType"
              />
            </Text>
            <Label>
              <FormattedMessage
                id="app.templateCSV.message.channelTypeInfo"
                defaultMessage={CHANNEL_TYPE_INFO}
              />
            </Label>
            <Label>
              <span style={{ background: '#eef5f6' }}>
                <FormattedMessage id="app.templateCSV.message.email" defaultMessage="EMAIL" />
              </span>
              –
              <FormattedMessage
                id="app.templateCSV.message.addressColumnDescription"
                defaultMessage="For an endpoint that can receive email messages."
              />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.templateCSV.message.addressColumn" />
            </Text>
            <Label>
              <FormattedMessage
                id="app.templateCSV.message.addressColumnInfo"
                defaultMessage={ADDRESS_COLUMN_INFO}
              />
            </Label>
          </View>
          <View display="flex" justifyContent="end">
            <Button primary onClick={downloadTemplate} data-testid="download-btn">
              <FormattedMessage id="app.templateCSV.donwload" defaultMessage="Close" />
            </Button>
            <Spacer width={15} />
            <Button tertiary onClick={close}>
              <FormattedMessage id="app.templateCSV.message.closeButton" defaultMessage="Close" />
            </Button>
          </View>
        </View>
      </PopoverController>
    </View>
  );
};

export default DownloadTemplate;
